// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"6535":"6cc8f9061b85d8cb907a","7004":"735308fa73b9edee73bd"}[chunkId] + "";
};